<template>
  <div ref="formcard"></div>
  <v-card
    class="py-4"
    :class="$vuetify.display.mobile ? `px-0` : `px6`"
    :loading="loading"
    :disabled="loading"
  >
    <v-card-title class="text-end">
      <span class="text-h4 mb-4"> {{ competitionName }}  - CSAPAT ADATAI </span>      
    </v-card-title>
    <v-card-text>
      <v-container class="text-start">
        <v-row>
          <v-col cols="12">
            <v-alert
              v-if="!isValidTeam"
              title="FIGYELEM"
              text="A csapat érvényes regisztrációjához kérjük adja meg iskolája és a csapat nevét, majd töltse ki a csapattagok és a felkészítő tanár adatait!"
              type="warning"
              closable
            ></v-alert>
            <v-alert
              v-if="isValidTeam"
              title="Érvényes"
              closable
              type="success"
              text="A csapat adatai megfelelően ki vannak töltve"
            ></v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h6 class="text-h6">Iskola adatai</h6>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              return-object
              :items="schoolList"
              label="Iskola neve"
              hint="Kezdje el beírni az iskola nevét, majd válasszon a listából"
              variant="underlined"
              @update:search="filterSchools"
              v-model="teamForm.school"
            >
              <template #no-data>
                <v-list-item>Nincs találat. Kezdjen el gépelni!</v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              type="text"
              :rules="textRulesTeam"
              label="Csapat neve"
              placeholder="Pl. A győztesek"
              hint="Adjon nevet a csapatnak!"
              variant="underlined"
              v-model="teamForm.name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn
          color="rsz500"
          class="w-100"
          size="x-large"
          @click="submitFormTeam"
          :disabled="!teamFormComplete"
          >MENTÉS</v-btn
        >
        <div v-if="hasTeam">
          <v-row>
            <v-col cols="12">
              <h6 class="text-h6">Felkészítő tanár adatai</h6>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                :rules="textRulesMembers"
                label="Vezetéknév"
                placeholder="Felkészítő tanár vezetékneve"
                variant="underlined"
                v-model="dataForm.teacherData.lastName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                :rules="textRulesMembers"
                label="Keresztnév"
                placeholder="Felkészítő tanár keresztneve"
                variant="underlined"
                v-model="dataForm.teacherData.firstName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                type="e-mail"
                label="E-mail"
                :rules="emailRules"
                placeholder="Felkészítő tanár email címe"
                variant="underlined"
                v-model="dataForm.teacherData.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                :rules="phoneRules"
                label="Mobilszám"
                placeholder="Felkészítő tanár mobilszáma"
                variant="underlined"
                v-model="dataForm.teacherData.phone"
              ></v-text-field>
            </v-col>
          </v-row>

          <div v-for="item in [1, 2, 3]" :key="item">
            <v-row>
              <v-col cols="12">
                <h6 class="text-h6">{{ item }}. csapattag adatai</h6>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  type="text"
                  :rules="textRulesMembers"
                  label="Vezetéknév"
                  placeholder="1. diák vezetékneve"
                  variant="underlined"
                  v-model="dataForm[`member${item}`].lastName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="text"
                  :rules="textRulesMembers"
                  label="Keresztnév"
                  placeholder="1. diák keresztneve"
                  variant="underlined"
                  v-model="dataForm[`member${item}`].firstName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  type="e-mail"
                  :rules="emailRules"
                  label="E-mail"
                  placeholder="1. diák email címe"
                  variant="underlined"
                  v-model="dataForm[`member${item}`].email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="text"
                  :rules="phoneRules"
                  label="Mobilszám"
                  placeholder="1. diák mobilszáma"
                  variant="underlined"
                  v-model="dataForm[`member${item}`].phone"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  type="date"
                  label="Születési dátum"
                  placeholder="1. diák születési dátum"
                  variant="underlined"
                  v-model="dataForm[`member${item}`].dob"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  type="number"
                  :rules="textRulesMembers"
                  label="Évfolyam"
                  placeholder="Évfolyam megadása"
                  variant="underlined"
                  v-model="dataForm[`member${item}`].year"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-row>
            <v-col cols="12">
              <v-btn
                color="rsz500"
                class="w-100"
                size="x-large"
                @click="submitFormMembers"
                :disabled="!formComplete"
                >MENTÉS</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <save-dialog
          v-if="isSaveDialogVisible"
          :showdialog="isSaveDialogVisible"
          @dialogChange="handleDialogChange"
        />
        <TeamNameTakenDialog
          v-if="isTeamDialogVisable"
          :showdialog="isTeamDialogVisable"
          @dialogChange="handleTeamDialogChange"
        />
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue'
import { getAllInstitutions } from '../services/adminServices'
import { checkTeamName, getTeam, postTeam } from '../services/teamServices'
import { getTeamMembers, postTeamMembers } from '../services/teamMemberServices'
import { checkTeam } from '../services/userServices'
import { getUserCompetitions } from '../services/formServices'
import { RszValidators } from '../modules/rszValidators'
import { isEmpty, values } from 'lodash/fp'
import SaveDialog from '../components/SaveDialog.vue'
import TeamNameTakenDialog from '../components/TeamNameTakenDialog.vue'

export default defineComponent({
  name: 'TeamRegistration',
  components: { SaveDialog, TeamNameTakenDialog },

  data() {
    return {
      competitionName: '',
      isSaveDialogVisible: false,
      isTeamDialogVisable: false,
      isValidTeam: false,
      schoolList: [],
      schools: [],
      formComplete: false,
      teamFormComplete: false,
      loading: false,
      test: null,
      hasTeam: false,
      teamForm: {
        name: null,
        school: null,
      },
      dataForm: {
        teacherData: {
          lastName: null,
          firstName: null,
          email: null,
          phone: null,
        },
        member1: {
          lastName: null,
          firstName: null,
          email: null,
          phone: null,
          dob: null,
          year: null,
        },
        member2: {
          lastName: null,
          firstName: null,
          email: null,
          phone: null,
          dob: null,
          year: null,
        },
        member3: {
          lastName: null,
          firstName: null,
          email: null,
          phone: null,
          dob: null,
          year: null,
        },
      },
      textRulesTeam: [
        (value) => {
          if (!value) return false
          if (RszValidators.stringPattern.test(value)) {
            this.validateForms()
            return true
          }
          this.teamFormComplete = false
          return `A mező érvénytelen karaktert tartalmaz!`
        },
      ],
      textRulesMembers: [
        (value) => {
          if (!value) return false
          if (RszValidators.stringPattern.test(value)) {
            this.validateForms()
            return true
          }
          this.formComplete = false
          return `A mező érvénytelen karaktert tartalmaz!`
        },
      ],
      emailRules: [
        (value) => {
          if (!value) return false
          if (RszValidators.emailPattern.test(value)) {
            this.validateForms()
            return true
          }
          this.formComplete = false
          return `Kérjük, érvényes email címet adjon meg!`
        },
      ],
      phoneRules: [
        (value) => {
          if (!value) return false
          if (value) {
            if (value.length < 8) {
              this.formComplete = false
              return `A telefonszám túl rövid!`
            }
            if (value.length > 21) {
              this.formComplete = false
              return `A telefonszám túl hosszú!`
            }
          }
          if (RszValidators.phonePattern.test(value)) {
            this.validateForms()
            return true
          }
          this.formComplete = false
          return `A telefonszám + jellel kezdődjön, amit az ország előhívója követ. A + jel után csak számokat adjon meg!`
        },
      ],
    }
  },
  async created() {
    const institutions = await getAllInstitutions()
    if (institutions) {
      this.schools = institutions
    }
    this.getTeamData()
    this.checkTeamValidity()
    this.getCompetitionName()
  },
  methods: {
    async getCompetitionName() {
      const comps = (await getUserCompetitions()).find(e => e.id === this.$route.params.competitionId)
      this.competitionName = comps.name
    },
    async checkTeamValidity() {
      this.isValidTeam = await checkTeam(this.$route.params.competitionId)
    },
    async getTeamData() {
      const responseTeam = await getTeam(this.$route.params.competitionId)
      if (!responseTeam.data) {
        this.hasTeam = false
        return
      }
      this.hasTeam = true

      const { name, value } = responseTeam.data
      this.teamForm.name = name
      this.teamForm.school = this.schools.filter((e) => e.value === value)[0]

      const responseMembers = await getTeamMembers(
        this.$route.params.competitionId
      )
      if (!responseMembers.data) return
      this.dataForm = responseMembers.data
    },
    filterSchools(val) {
      if (val.length > 2) {
        this.schoolList = this.schools.filter((school) => {
          return school.title.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
    },
    async submitFormTeam() {
      // this.loading = true
      this.$refs.formcard.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })

      const checkTeamNameVal = await checkTeamName(this.teamForm.name, this.$route.params.competitionId)
      if (!checkTeamNameVal) {
        this.isTeamDialogVisable = true
        return
      }
      this.isSaveDialogVisible = true
      setTimeout(() => {
        this.isSaveDialogVisible = false
      }, 1500)
      const result = await postTeam(this.teamForm, this.$route.params.competitionId)
      this.hasTeam = result.data
    },
    async submitFormMembers() {
      // this.loading = true
      this.$refs.formcard.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
      this.isSaveDialogVisible = true
      setTimeout(() => {
        this.isSaveDialogVisible = false
      }, 1500)
      const result = (
        await postTeamMembers(this.dataForm, this.$route.params.competitionId)
      ).data
      if (result) {
        this.checkTeamValidity()
      }
    },

    validateForms() {
      this.formComplete =
        !values(this.dataForm.teacherData).every((a) => !a) &&
        !values(this.dataForm.member1, isEmpty).every((a) => !a)
      this.teamFormComplete = !values(this.teamForm).every((a) => !a)
    },
    handleDialogChange() {
      this.isSaveDialogVisible = false
    },
    handleTeamDialogChange() {
      this.isTeamDialogVisable = false
    },
  },
})
</script>
